<template>
  <section id="tim" class="bg-white py-16 sm:py-24">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="lg:grid lg:grid-cols-3 lg:gap-12">
        <div class="lg:col-span-1">
          <span class="section-badge">Tím</span>
          <h2 class="section-title mt-4 lg:text-left">O nás</h2>
          <p class="mt-4 text-lg leading-7 text-gray-600 lg:max-w-sm">
            Sme mladý a ambiciózny tím s dlhoročnými skúsenosťami v oblasti
            informačných technológií.
          </p>
        </div>

        <div class="mt-12 space-y-8 lg:col-span-2 lg:mt-0">
          <article
            v-for="member in team"
            :key="member.name"
            class="card-surface overflow-hidden"
          >
            <div class="sm:flex">
              <div class="sm:w-48 shrink-0">
                <img
                  :src="member.image"
                  :alt="member.name"
                  class="h-56 w-full object-cover object-top sm:h-full sm:min-h-[12rem]"
                />
              </div>
              <div class="flex flex-1 flex-col justify-center p-6 sm:p-8">
                <h3 class="text-xl font-bold text-gray-900">
                  {{ member.name }}
                </h3>
                <p class="mt-1 text-sm font-semibold text-brand-600">
                  {{ member.role }}
                </p>
                <p class="mt-4 text-sm leading-6 text-gray-600">
                  {{ member.bio }}
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import matusImg from "@/assets/matus-min.png";
import milanImg from "@/assets/milan-min.jpg";

export default {
  setup() {
    return {
      team: [
        {
          name: "Ing. Matúš Múčka",
          role: "Spoluzakladateľ",
          image: matusImg,
          bio: "Špecializujem sa na vývoj moderných responzívnych aplikácií, dizajn, databázové systémy a virtualizáciu. Medzi moje záujmy patrí beh, cestovanie a vegánska kuchyňa.",
        },
        {
          name: "Ing. Milan Múčka",
          role: "Spoluzakladateľ",
          image: milanImg,
          bio: "Špecializujem sa na bezpečnú komunikáciu, kryptografiu, návrh a vývoj embedded zariadení na rôznych platformách. Vo voľnom čase turistika, plávanie a čítanie.",
        },
      ],
    };
  },
};
</script>
